import { render, staticRenderFns } from "./PixSection.vue?vue&type=template&id=0d3f8fc2&scoped=true"
import script from "./PixSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PixSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PixSection.vue?vue&type=style&index=0&id=0d3f8fc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3f8fc2",
  null
  
)

export default component.exports